export default [{
  value: 'first_quarter',
  text: '1er Cuatrimestre'
}, {
    value: 'second_quarter',
    text: '2do Cuatrimestre'
  }, {
  value: 'yearly',
  text: 'Anual'
}]



// WEBPACK FOOTER //
// ./src/data/subjectDuration.js